import { POSITRON } from "@carto/react-basemaps";
import { API_VERSIONS } from "@deck.gl/carto";

export const initialState = {
  viewState: {
    latitude: 51.5099234248025,
    longitude: -0.11546314455129104,
    zoom: 12.5,
    pitch: 0,
    bearing: 0,
    dragRotate: false,
  },
  basemap: POSITRON,
  //basemap: GOOGLE_SATELLITE,
  credentials: {
    apiVersion: API_VERSIONS.V3,
    apiBaseUrl: "https://gcp-us-east1.api.carto.com",
  },
  credentials2: {
    username: "tnederlof",
    apiKey: "551d05a437c7f6f81640f7fc87d9a2c62afc9f08",
    serverUrlTemplate: "https://{user}.carto.com",
  },
  googleApiKey: "AIzaSyCCq0PJSklkxTwsvsN8lXE6Yqk6Aqs5G_A", // only required when using a Google Basemap,
  oauth: {
    domain: "auth.carto.com",
    // Type here your application client id
    clientId: "6JS9QGtRJ7pwmc0GmIxNHo5V6P9eKyip",
    scopes: [
      "read:current_user",
      "update:current_user",
      "read:connections",
      "write:connections",
      "read:maps",
      "write:maps",
      "read:account",
      "admin:account",
    ],
    audience: "carto-cloud-native-api",
    authorizeEndPoint: "https://carto.com/oauth2/authorize", // only valid if keeping https://localhost:3000/oauthCallback
  },
};
